import { createReducer } from "@ngrx/store";
// import { platformTestAction } from "./platform.actions";

export interface PlatformState {
  // test: number
}

export const PLATFORM_FEATURE_KEY = 'platform';

const initialState: PlatformState = {
  // test: 1,
};

export const platformReducer = createReducer(
  initialState,
  // on(platformTestAction, (state, { test }) => ({
  //   ...state,
  //   test
  // }))
);
